import React, { useEffect, useState } from "react";
import { CiSearch } from "react-icons/ci";
import { PiDoor, PiMicrosoftExcelLogo } from "react-icons/pi";
import { TfiLayoutAccordionMerged } from "react-icons/tfi";
import { FaDoorClosed, FaDoorOpen, FaImage } from "react-icons/fa";
import { TbDoorOff } from "react-icons/tb";

import Sidebar from "../components/Sidebar";
import TempChart from "../components/graphsConfig/TempChart";
import HumChart from "../components/graphsConfig/HumChart";
import Co2Chart from "../components/graphsConfig/Co2Chart";
import EhtChart from "../components/graphsConfig/EhtChart";
import AllChart from "../components/graphsConfig/AllChart";

import LoaderGif from "../assets/images/Loader.gif";

// import TempChart from "../components/reactChartsJs/TempChart";

import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { fetchData, fetchPortsData, getConvertedDates, getWeekDifference, processData, processPortsData } from "../components/helpers/dataHandler";
import { takeScreenShot } from "../components/utils/takeScreenShot";

const Graphiques = () => {
    const [selectedChambre, setSelectedChambre] = useState("ch1");
    const [startDate, setStartDate] = useState("");
    const [endDate, setEndDate] = useState("");

    const [co2, setCo2] = useState([]);
    const [ethylene, setEthylene] = useState([]);
    const [humidite, setHumidite] = useState([]);
    const [temperature, setTemperature] = useState([]);

    const [time, setTime] = useState([]);
    const [annotation, setAnnotation] = useState([]);
    const [allChart, setShowAllChart] = useState(false);
    const [loading, SetLoading] = useState(false);
    const [isDoorsChecked, setIsDoorsChecked] = useState(false);
    const [titleShowed, setTitleShowed] = useState(false);

    const [co2Seuil, setCo2Seuil] = useState([]);
    const [temperatureSeuil, setTemperatureSeuil] = useState([]);
    const [humiditeSeuil, setHumiditeSeuil] = useState([]);
    const [ethyleneSeuil, setEthyleneSeuil] = useState([]);

    // Export Data :
    const [co2Exp, setCo2Exp] = useState([]);
    const [ethyleneExp, setEthyleneExp] = useState([]);
    const [humiditeExp, setHumiditeExp] = useState([]);
    const [temperatureExp, setTemperatureExp] = useState([]);

    let exportFileName = `PDever Chambre ${selectedChambre} - Date(${convertTimestampToFrenchDate(startDate)} - ${convertTimestampToFrenchDate(endDate)})`

    const handleChartsData = async () => {
        try {
            if (startDate >= endDate) {
                notifyInfo("La date de début doit être inférieure à la date de fin")
                return;
            }
            SetLoading(true);
            const { convertedDateStart, convertedDateEnd } = getConvertedDates(startDate, endDate);

            const timeArr = [1, 4, 8, 11];

            const diffInWeeks = getWeekDifference(convertedDateStart, convertedDateEnd);
            console.log("diffInWeeks ", diffInWeeks);

            const dataResult = await fetchData(convertedDateStart, convertedDateEnd, selectedChambre);
            // Fetch ports data without pagination
            const portsResult = await fetchPortsData(convertedDateStart, convertedDateEnd, selectedChambre);

            const processDataResult = processData(dataResult, timeArr[diffInWeeks]);
            const processDorDataResult = processPortsData(portsResult);

            setChartData(processDataResult);
            setExportData(processDataResult);
            setAnnotation(processDorDataResult);

            SetLoading(false);
        } catch (error) {
            console.error("Error getting data within time range:", error);
        }
    };

    // Helper functions

    const [disableShowAllCharts, setDisableShowAllCharts] = useState(false);
    const currentWidth = window.innerWidth;

    useEffect(() => {
        if (currentWidth <= 500) {
            setDisableShowAllCharts(true)
        } else if (currentWidth > 500 && currentWidth >= 1500) {
            setDisableShowAllCharts(false)
        }
    }, [currentWidth]);

    const setChartData = (result) => {
        setTime(result.time);
        setCo2(result.co2);
        setEthylene(result.ethylene);
        setHumidite(result.humidite);
        setTemperature(result.temperature);


        //TODO : send the data to the charts 
        setCo2Seuil(result.co2Seuil);
        setEthyleneSeuil(result.ethyleneSeuil);
        setHumiditeSeuil(result.humiditeSeuil);
        setTemperatureSeuil(result.temperatureSeuil);
    };

    const setExportData = (result) => {
        setCo2Exp(result.co2Export);
        setEthyleneExp(result.ethExport);
        setHumiditeExp(result.humExport);
        setTemperatureExp(result.tempExport);
    };

    useEffect(() => {
        const today = new Date();
        const yesterday = new Date(today.getTime() - 24 * 60 * 60 * 1000);

        const formatDateTime = (date) => {
            const year = date.getFullYear();
            let month = date.getMonth() + 1;
            if (month < 10) {
                month = "0" + month;
            }
            let day = date.getDate();
            if (day < 10) {
                day = "0" + day;
            }
            let hours = date.getHours();
            if (hours < 10) {
                hours = "0" + hours;
            }
            let minutes = date.getMinutes();
            if (minutes < 10) {
                minutes = "0" + minutes;
            }
            return `${year}-${month}-${day}T${hours}:${minutes}`;
        };

        setStartDate(formatDateTime(yesterday));
        setEndDate(formatDateTime(today));
    }, []);

    // ==========================| Notify Toast |==========================

    const notifySuccess = (msg) =>
        toast.success(msg, {
            position: "top-right",
            autoClose: 3000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "colored",
        });

    const notifyInfo = (msg) =>
        toast.info(msg, {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: false,
            draggable: true,
            progress: undefined,
            theme: "colored",
        });


    // ====================================================================

    // =====================| image Exportation |====================

    const handleScreenShot = () => {
        if (ethylene.length === 0) {
            notifyInfo("Il n'y a pas de données à exporter");
            return;
        }

        setTitleShowed(true); // Show the title before taking a screenshot

        setTimeout(() => {
            if (allChart) {
                takeScreenShot("1ChartsToPrint", exportFileName);
            } else {
                takeScreenShot("4ChartsToPrint", exportFileName);
            }

            setTimeout(() => {
                setTitleShowed(false); // Hide the title after the screenshot is taken
            }, 50); // Give enough time for the screenshot to process
        }, 50); // Small delay to ensure UI updates
    };



    // ====================================================================

    // =====================| Data Exportation To CSV |====================

    const dataExport = () => {
        let result = `Time, Temperature, Humidite, CO2, Ethylene\n`;
        const dataLenght = time.length;
        for (let i = 0; i < dataLenght; i++) {
            result += `${time[i].replace(",", " ")}, ${temperatureExp[i]}, ${humiditeExp[i]
                }, ${co2Exp[i]}, ${ethyleneExp[i]},\n`;
        }
        return result;
    };

    async function exportToExcel() {
        if (time.length > 0) {
            const fileData = await dataExport();
            const blob = new Blob([fileData], { type: "text/plain" });
            const url = URL.createObjectURL(blob);
            const link = document.createElement("a");
            const date = new Date();

            let name;
            if (selectedChambre === "ch3") {
                name = "Chambre 03";
            } else if (selectedChambre === "ch4") {
                name = "Chambre 04";
            } else if (selectedChambre === "ch5") {
                name = "Chambre 05";
            } else if (selectedChambre === "ch6") {
                name = "Chambre 06";
            } else {
                name = "Chmabre 03";
            }

            link.download = `${exportFileName}.csv`;
            link.href = url;
            link.click();
            notifySuccess("Les données téléchargées avec succès");
        } else {
            console.error("Time array is empty or undefined.");
            notifyInfo("Il n'y a pas de données!");
        }
    }

    const handlesetShowAllChart = () => {
        setShowAllChart(!allChart);
    };

    // ====================================================================

    function convertTimestampToFrenchDate(input) {
        const date = new Date(input);

        if (isNaN(date.getTime())) {
            return "Date invalide";
        }

        const options = {
            year: "numeric",
            month: "long",
            day: "2-digit",
            hour: "2-digit",
            minute: "2-digit",
            // second: "2-digit",
            hour12: false, // 24-hour format
        };

        return date.toLocaleDateString("fr-FR", options);
    }

    return (
        <div className="flex lg:gap-5 bg-[#fffcf6]">
            <Sidebar />
            <main className="flex-1 mx-auto pl-2 lg:pl-0 py-4 pr-2 lg:pr-4 h-screen overflow-y-scroll" id="ChartsToPrint">
                <ToastContainer
                    position="top-right"
                    autoClose={3000}
                    limit={1}
                    hideProgressBar={false}
                    newestOnTop={false}
                    closeOnClick
                    rtl={false}
                    pauseOnFocusLoss
                    draggable
                    pauseOnHover={false}
                    theme="colored"
                />
                <p className="text-3xl lg:text-3xl font-bold mb-2 text-center md:text-left">Graphiques</p>


                {/* Options */}
                <div className="flex flex-wrap items-end justify-between ml-2">
                    <div className="w-full lg:w-3/4 flex flex-wrap">
                        <div className="w-full lg:w-1/3 lg:pr-2 ">
                            <p className="font-semibold">Chambres</p>
                            <select
                                className="w-full border border-gray p-2 rounded-md outline-none pr-16"
                                value={selectedChambre}
                                onChange={(e) => setSelectedChambre(e.target.value)}
                            >
                                <option value='ch1' selected>Chambre 01</option>
                                <option value='ch2'>Chambre 02</option>
                                <option value='ch3'>Chambre 03</option>
                                <option value='ch4'>Chambre 04</option>
                                <option value='ch5'>Chambre 05</option>
                                <option value='ch6'>Chambre 06</option>
                                <option value='ch7'>Chambre 07</option>
                                <option value='ch8'>Chambre 08</option>
                                <option value='ch9'>Chambre 09</option>
                                <option value='ch10'>Chambre 10</option>
                                <option value='ch11'>Chambre 11</option>
                            </select>
                        </div>

                        <div className="w-full lg:w-1/3 lg:pr-2 mt-3 md:mt-0">
                            <p className="font-semibold">Date de début</p>
                            <input
                                type="datetime-local"
                                className="w-full border border-gray p-2 rounded-md outline-none"
                                value={startDate}
                                onChange={(e) => setStartDate(e.target.value)}
                            />
                        </div>

                        <div className="w-full lg:w-1/3 lg:pr-2 mt-3 md:mt-0">
                            <p className="font-semibold">Date de fin</p>
                            <input
                                type="datetime-local"
                                className="w-full border border-gray p-2 rounded-md outline-none"
                                value={endDate}
                                onChange={(e) => setEndDate(e.target.value)}
                            />
                        </div>
                    </div>

                    {/* Buttons */}
                    <div className="w-full lg:w-1/4 flex items-end justify-end">
                        <button
                            className={`bg-primary rounded-md mr-2 py-2 px-4 mt-4 ${loading ? "opacity-50 cursor-not-allowed" : ""}`}
                            onClick={() => handleChartsData()}
                            disabled={loading} // Disable button
                            title="Rechercher"
                        >
                            <CiSearch size={27} color="white" strokeWidth={1} />
                        </button>

                        <button
                            className={`bg-primary rounded-md mr-2 py-2 px-4 mt-4 ${loading ? "opacity-50 cursor-not-allowed" : ""}`}
                            onClick={() => setIsDoorsChecked(!isDoorsChecked)}
                            disabled={loading} // Disable button
                            title="Afficher les portes sur le chart"
                        >
                            {isDoorsChecked ? <PiDoor size={27} color="white" strokeWidth={1} /> : <TbDoorOff size={27} color="white" strokeWidth={1} />}
                        </button>

                        <button
                            className={`${disableShowAllCharts ? 'hidden' : ''} bg-primary rounded-md mr-2 py-2 px-4 mt-4 ${loading ? "opacity-50 cursor-not-allowed" : ""}`}
                            onClick={() => handlesetShowAllChart()}
                            disabled={loading} // Disable button
                            title="Fusionner les graphiques en un seul"
                        >
                            <TfiLayoutAccordionMerged size={27} color="white" strokeWidth={1} />
                        </button>

                        <button
                            className={`bg-primary rounded-md mr-2 py-2 px-4 mt-4 ${loading ? "opacity-50 cursor-not-allowed" : ""}`}
                            onClick={() => exportToExcel()}
                            disabled={loading} // Disable button
                            title="Exporter en Excel"
                        >
                            <PiMicrosoftExcelLogo size={27} color="white" strokeWidth={1} />
                        </button>

                        <button
                            className={`bg-primary rounded-md lg:mr-2 py-2 px-4 mt-4 ${loading ? "opacity-50 cursor-not-allowed" : ""}`}
                            onClick={() => handleScreenShot()}
                            disabled={loading} // Disable button
                            title="Exporter les graphiques en image"
                        >
                            <FaImage size={27} color="white" strokeWidth={1} />
                        </button>
                    </div>
                </div>

                {/* Charts */}

                {loading ? (
                    <div className="flex justify-center items-center h-screen">
                        <img src={LoaderGif} alt="Loading..." className="w-40 h-40" />
                    </div>

                ) : (
                    <div className="mt-2 w-full">
                        {allChart ? (
                            <div id="1ChartsToPrint">
                                <div className={`bg-white rounded-lg p-2 m-1 bg border border-gray  ${!titleShowed ? 'hidden' : ''}`}>
                                    <p className='text-center'>
                                        Chambre : <b>{selectedChambre}</b> &nbsp; | &nbsp;
                                        Date de début : <b>{convertTimestampToFrenchDate(startDate)}</b> &nbsp; | &nbsp;
                                        Date de fin : <b>{convertTimestampToFrenchDate(endDate)}</b>
                                    </p>

                                </div>
                                <AllChart
                                    temperature={temperature}
                                    humidite={humidite}
                                    co2={co2}
                                    ethylene={ethylene}
                                    annotation={annotation}
                                    name={`Tous les capteurs`}
                                    isDoorsChecked={isDoorsChecked}
                                />
                            </div>
                        ) : (
                            <div id="4ChartsToPrint">
                                <div className={`bg-white rounded-lg p-2 m-1 bg border border-gray  ${!titleShowed ? 'hidden' : ''}`}>
                                    <p className='text-center'>
                                        Chambre : <b>{selectedChambre}</b> &nbsp; | &nbsp;
                                        Date de début : <b>{convertTimestampToFrenchDate(startDate)}</b> &nbsp; | &nbsp;
                                        Date de fin : <b>{convertTimestampToFrenchDate(endDate)}</b>
                                    </p>

                                </div>
                                <div className="flex flex-wrap justify-between">
                                    <div className="w-full lg:w-1/2 p-1">
                                        <TempChart temperature={temperature} annotation={annotation} isDoorsChecked={isDoorsChecked} />
                                    </div>
                                    <div className="w-full lg:w-1/2 p-1">
                                        <HumChart humidite={humidite} annotation={annotation} isDoorsChecked={isDoorsChecked} />
                                    </div>
                                </div>
                                <div className="flex flex-wrap justify-between">
                                    <div className="w-full lg:w-1/2 p-1">
                                        <Co2Chart co2={co2} annotation={annotation} isDoorsChecked={isDoorsChecked} />
                                    </div>
                                    <div className="w-full lg:w-1/2 p-1">
                                        <EhtChart ethylene={ethylene} annotation={annotation} isDoorsChecked={isDoorsChecked} />
                                    </div>
                                </div>
                            </div>
                        )}
                    </div>
                )}

            </main>
        </div>
    );
};

export default Graphiques;
